import React from "react";

const GroupInbox = () => {
  return (
    <>
      <div className="chat-list__items">
        <div className="chat-list__empty">Không có tin nhắn nhóm</div>
      </div>
    </>
  );
};
export default GroupInbox;
